<div class="header">
  <div class="title">
    <fa-icon [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin']" routerLinkActive="router-link-active"
      appChangeColorTheme attribute="color"></fa-icon>
    <h2>{{title}}</h2>
  </div>
</div>

<div class="wrap">
  <ng-container *ngFor="let m of menu">
    <ng-container>
      <mat-card [ngSwitch]="m.iconType" *ngIf="m.iconLabel !== 'faFileExcel'" (click)="exportExcel(m.keyWord)">
        <div class="header">
          <fa-icon *ngSwitchCase="'faicon'" [icon]="getFaIcon(m.icon)" appChangeColorTheme attribute="color"></fa-icon>
          <img [src]="m.icon" alt="club" *ngSwitchCase="'club'">
        </div>

        <mat-card-content appChangeColorTheme attribute="bgc">
          <h4><strong>{{m.name}}</strong></h4>
          <p>{{m.description}}</p>
        </mat-card-content>
      </mat-card>
    </ng-container>
  </ng-container>
</div>
